import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { AdminDepositRoute } from '@/modules/deposit/routes/admin-deposit.route'
import { DepositPayOffRequestModel, DepositRequestModel } from '@/modules/deposit/models/deposit-request.model'

@vservice()
export class AdminDepositService {
  constructor(
    private readonly routes: AdminDepositRoute
  ) {
  }

  update(id: number, data: DepositRequestModel) {
    return Inertia.post(
      this.routes.update(id),
      data
    )
  }

  store(data: DepositRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  payOff(id: number, data: DepositPayOffRequestModel) {
    return Inertia.post(
      this.routes.payOff(id),
      data,
      { preserveState: true }
    )
  }
}